module.exports = __webpack_public_path__ + "img/15.8339fa96.svg";